import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import { missionContent } from "./aboutContent";

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const AboutMission = () => (
  <section
    className="bg-gray-50 py-14 lg:py-20"
    aria-labelledby="about-mission-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-mission-heading"
        title={missionContent.title}
        subtitle={missionContent.subtitle}
      />
      <p className="mx-auto max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {missionContent.intro}
      </p>
      <motion.ul
        className="mx-auto mt-8 grid max-w-4xl list-none grid-cols-1 gap-4 p-0 sm:grid-cols-2"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {missionContent.outcomes.map((outcome) => (
          <motion.li
            key={outcome}
            variants={itemVariants}
            className="flex items-start gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-sm"
          >
            <FiCheckCircle
              aria-hidden="true"
              size={20}
              className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
            />
            <span className="text-sm md:text-base text-gray-700">{outcome}</span>
          </motion.li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default AboutMission;
